import { makeStyles, TableCell, TableRow, withStyles } from "@material-ui/core";
import { colors } from "../../../constants/colors/Colors";

export const useStyles = makeStyles((theme) => ({
    eventContainer: {
        borderRadius: 12,
    },
    tablesContainer: {
        paddingTop: 10,
        paddingLeft: 30,
        paddingRight: 30,
        width: '100%'
    },

    tableSubDiv: {
        width: 832,
        height: 313,
        display: "flex",
        flexDirection: "column",
        alignItems: "flexStart",
        padding: "30px",
        border: "1px solid #D4DDE4",
        boxSizing: "borderBox",
        borderRadius: "12px",
        marginBottom: 30,
        [theme.breakpoints.down('md')]: {
            width: '100%',
            height: 'fit-content'
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: 'fit-content'
        },
    },
    searchSubTable: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 30,
        outline: "none",
        padding: "15px",
        width: 566,
        height: 52,
        background: "#FAFAFB",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    grayIcon: {
        display: "flex",
        alignItems: "center",
        height: "16px",
        width: "16px",
        marginLeft: 4,
    },
    iconImage: {
        width: "100%",
        height: "100%"
    },
    direction: {
        display: "flex",
        alignItems: "center"
    },
    tableTitleCredit: {
        color: colors.titleColor,
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '500',
    },
    tablesubAvailable: {
        color: colors.titleColor,
        letterSpacing: '-0.001em',
        fontSize: 26,
        fontWeight: '500',
        lineHeight: "30px"

    },
    tableTitleCreditPrice: {
        color: colors.titleColor,
        letterSpacing: '-0.001em',
        fontSize: 30,
        fontWeight: '500',
        lineHeight: "36px",
        marginTop: "20px",
    },
    subTableInput: {
        height: 52,
        width: "100%",
        marginTop: 10,
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: 8,
        background: '#FAFAFB',
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 15,
        outline: "none",
    },
    subTableButton: {
        marginTop: "29px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "12px 14px",
        background: "linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)",
        borderRadius: "6px",
        border: "none",
        color: 'white',
        fontWeight: 600,
        fontSize: "16",
        lineHeight: "22px",
        cursor: 'pointer',
    },


    tableSubCredit: {
        fontWeight: 600,
        marginTop: "20px",
        fontSize: 16,
        lineHeight: "22px"
    },
    searchAndButtonsRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: "20px",
        "@media (max-width: 1200px)": {
            display: 'block',
        },
    },
    inputWithIconContainer: {
        width: '100%',
        display: "inline-flex",
        alignItems: 'center',
    },
    searchInput: {
        height: 52,
        width: 566,
        backgroundColor: '#FAFAFB',
        borderRadius: 8,
        color: '#5B6773',
        border: '1px solid #D4DDE4',
        boxSizing: 'border-box',
        paddingLeft: 15,
        letterSpacing: '-0.1px',
        fontSize: 14,
        fontWeight: '400',
        fontStyle: 'normal',
        paddingRight: 60,
        "@media (max-width: 1500px)": {
            width: '80%'
        },
        "@media (max-width: 1200px)": {
            width: '100%',
        },
    },
    iconContainer1: {
        backgroundColor: '#FAFAFB',
        width: 30,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        right: 33.5,
        height: 42,
        "@media (max-width: 1200px)": {
            position: 'absolute',
            right: 60,
        },
    },
    btnsRow: {
        display: 'inline-flex',
        "@media (max-width: 1200px)": {
            justifyContent: 'space-between',
            width: '100%',
            marginTop: 20,
        },
    },
    creditNumber: {
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '400',
        fontStyle: 'normal',
        whiteSpace: 'nowrap',
        "@media (max-width: 568px)": {
            fontSize: 14,
        },
    },
    allBtnsContainer: {
        marginLeft: 60,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        "@media (max-width: 1200px)": {
            marginLeft: 0,
        },
    },
    twoBtnsContainer: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    singleBtnContainer: {
        height: 52,
        width: 52,
        backgroundColor: '#FFFFFF',
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10,
        cursor: 'pointer',
        "@media (max-width: 568px)": {
            width: 32,
            height: 32,
            marginRight: 5,
        },
        "@media (max-width: 375px)": {
            width: 22,
            height: 22,
            marginRight: 5,
        },
    },
    iconImg: {
        "@media (max-width: 568px)": {
            width: 12,
            height: 12,
        },
        "@media (max-width: 375px)": {
            width: 8,
            height: 8,
        },
    },
    threeBtnsContainer: {
        display: 'inline-flex',
        marginLeft: 17,
        alignItems: 'center',
        "@media (max-width: 568px)": {
            marginLeft: 7,
        },
    },
  
    table: {
        minWidth: 950,
        [theme.breakpoints.down('sm')]: {
            width: 1500,
        },
    }
}))

export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#5B6773',
        color: '#ffffff',
        height: 52,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        paddingLeft: 30
    },
    body: {
        fontSize: 14,
        height: 52,
        color: '#5B6773',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        paddingLeft: 30,
    },

}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F4F6F8',
        },
    },
}))(TableRow);
